import { render, staticRenderFns } from "./InputHandler.vue?vue&type=template&id=5236b7c4&scoped=true&"
import script from "./InputHandler.vue?vue&type=script&lang=js&"
export * from "./InputHandler.vue?vue&type=script&lang=js&"
import style0 from "./InputHandler.vue?vue&type=style&index=0&id=5236b7c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5236b7c4",
  null
  
)

export default component.exports